const translationsFarmerDashboard = {
  en: {
    // General UI
    yourOrders: 'Your Orders',
    selectLanguage: 'Select Language',
    english: 'English',
    hindi: 'Hindi',
    marathi: 'Marathi',
    noOrdersPlaced: 'No orders placed yet.',
    worker: 'Worker',
    plural: 's',
    orderDetails: 'Order Details',
    locationAndContact: 'Location & Contact',
    paymentInfo: 'Payment Info',
    additionalInfo: 'Additional Info',
    unassigned: 'Unassigned',
    none: 'None',
    na: 'N/A',
    unknown: 'Unknown',
    day: 'Day',
    bundle: 'Bundle',
    maleWorkers: 'Male Workers',
    femaleWorkers: 'Female Workers',
    hours: 'Hours',
    days: 'Days',
    startDate: 'Start Date',
    endDate: 'End Date',
    startTime: 'Start Time',
    estimatedCompletion: 'Estimated Completion',
    address: 'Address',
    contact: 'Contact',
    location: 'Location',
    cost: 'Cost',
    paymentMethod: 'Payment Method',
    paymentStatus: 'Payment Status',
    note: 'Note',
    cancelWithin: 'Cancel within',
    cancelOrder: 'Cancel Order',
    cancelling: 'Cancelling...',
    paid: 'Paid',
    paidUnknown: 'Paid (Unknown Method)',
    notPaid: 'Not Paid',

    // Service Types
    'farm-workers': 'Farm Workers',
    ownertc: 'Owner Tractor',

    // Statuses
    assigned: 'Assigned',
    pending: 'Pending',
    completed: 'Completed',
    cancelled: 'Cancelled',
    accepted: 'Accepted',
    rejected: 'Rejected',

    // Payment Methods
    cash: 'Cash',
    online: 'Online',

    // Error Messages
    errorAccessRestricted: 'Access restricted to farmers.',
    errorPleaseLogIn: 'Please log in as a farmer.',
    errorFetchingOrders: 'Error fetching orders: {message}',
    errorInitialization: 'Initialization error: {message}',
    errorAuthentication: 'Authentication error: {message}',
    errorInvalidPhone: 'Farmer phone number is missing or invalid.',
    errorSendingWhatsApp: 'Failed to send WhatsApp message: {message}',
    errorCancellingOrder: 'Failed to cancel order: {message}',

    // Success Messages
    successOrderCancelled: 'Order cancelled successfully.',

    // WhatsApp Message
    workerAcceptedMessage: 'All workers have accepted your order and will arrive at your location ({location}) soon. You can contact: {workerDetails}. Regards, Khetisathi'
  },
  hi: {
    // General UI
    yourOrders: 'आपके ऑर्डर',
    selectLanguage: 'भाषा चुनें',
    english: 'अंग्रेजी',
    hindi: 'हिंदी',
    marathi: 'मराठी',
    noOrdersPlaced: 'अभी तक कोई ऑर्डर नहीं दिया गया।',
    worker: 'कामगार',
    plural: '',
    orderDetails: 'ऑर्डर विवरण',
    locationAndContact: 'स्थान और संपर्क',
    paymentInfo: 'भुगतान जानकारी',
    additionalInfo: 'अतिरिक्त जानकारी',
    unassigned: 'असाइन नहीं किया गया',
    none: 'कोई नहीं',
    na: 'उपलब्ध नहीं',
    unknown: 'अज्ञात',
    day: 'दिन',
    bundle: 'बंडल',
    maleWorkers: 'पुरुष कामगार',
    femaleWorkers: 'महिला कामगार',
    hours: 'घंटे',
    days: 'दिन',
    startDate: 'प्रारंभ तिथि',
    endDate: 'समाप्ति तिथि',
    startTime: 'प्रारंभ समय',
    estimatedCompletion: 'अनुमानित समापन',
    address: 'पता',
    contact: 'संपर्क',
    location: 'स्थान',
    cost: 'लागत',
    paymentMethod: 'भुगतान विधि',
    paymentStatus: 'भुगतान स्थिति',
    note: 'टिप्पणी',
    cancelWithin: 'इसके भीतर रद्द करें',
    cancelOrder: 'ऑर्डर रद्द करें',
    cancelling: 'रद्द हो रहा है...',
    paid: 'भुगतान किया गया',
    paidUnknown: 'भुगतान किया गया (अज्ञात विधि)',
    notPaid: 'भुगतान नहीं किया गया',

    // Service Types
    'farm-workers': 'खेत कामगार',
    ownertc: 'स्वामी ट्रैक्टर',

    // Statuses
    assigned: 'नियुक्त',
    pending: 'लंबित',
    completed: 'पूरा हुआ',
    cancelled: 'रद्द',
    accepted: 'स्वीकृत',
    rejected: 'अस्वीकृत',

    // Payment Methods
    cash: 'नकद',
    online: 'ऑनलाइन',

    // Error Messages
    errorAccessRestricted: 'केवल किसानों के लिए पहुंच प्रतिबंधित है।',
    errorPleaseLogIn: 'कृपया किसान के रूप में लॉग इन करें।',
    errorFetchingOrders: 'ऑर्डर प्राप्त करने में त्रुटि: {message}',
    errorInitialization: 'प्रारंभ करने में त्रुटि: {message}',
    errorAuthentication: 'प्रमाणीकरण त्रुटि: {message}',
    errorInvalidPhone: 'किसान का फोन नंबर गायब या अमान्य है।',
    errorSendingWhatsApp: 'व्हाट्सएप संदेश भेजने में विफल: {message}',
    errorCancellingOrder: 'ऑर्डर रद्द करने में विफल: {message}',

    // Success Messages
    successOrderCancelled: 'ऑर्डर सफलतापूर्वक रद्द किया गया।',

    // WhatsApp Message
    workerAcceptedMessage: 'सभी कामगारों ने आपके ऑर्डर को स्वीकार कर लिया है और जल्द ही आपके स्थान ({location}) पर पहुंचेंगे। आप संपर्क कर सकते हैं: {workerDetails}। नमस्ते, खेतिसाथी'
  },
  mr: {
    // General UI
    yourOrders: 'तुमचे ऑर्डर',
    selectLanguage: 'भाषा निवडा',
    english: 'इंग्रजी',
    hindi: 'हिंदी',
    marathi: 'मराठी',
    noOrdersPlaced: 'अद्याप कोणतेही ऑर्डर दिलेले नाहीत.',
    worker: 'कामगार',
    plural: '',
    orderDetails: 'ऑर्डर तपशील',
    locationAndContact: 'स्थान आणि संपर्क',
    paymentInfo: 'पेमेंट माहिती',
    additionalInfo: 'अतिरिक्त माहिती',
    unassigned: 'नियुक्त केलेले नाही',
    none: 'काही नाही',
    na: 'उपलब्ध नाही',
    unknown: 'अज्ञात',
    day: 'दिवस',
    bundle: 'बंडल',
    maleWorkers: 'पुरुष कामगार',
    femaleWorkers: 'महिला कामगार',
    hours: 'तास',
    days: 'दिवस',
    startDate: 'प्रारंभ तारीख',
    endDate: 'समाप्ती तारीख',
    startTime: 'प्रारंभ वेळ',
    estimatedCompletion: 'अंदाजे पूर्णता',
    address: 'पत्ता',
    contact: 'संपर्क',
    location: 'स्थान',
    cost: 'खर्च',
    paymentMethod: 'पेमेंट पद्धत',
    paymentStatus: 'पेमेंट स्थिती',
    note: 'टिप',
    cancelWithin: 'या आत रद्द करा',
    cancelOrder: 'ऑर्डर रद्द करा',
    cancelling: 'रद्द होत आहे...',
    paid: 'पैसे दिले',
    paidUnknown: 'पैसे दिले (अज्ञात पद्धत)',
    notPaid: 'पैसे दिले नाहीत',

    // Service Types
    'farm-workers': 'शेत कामगार',
    ownertc: 'मालक ट्रॅक्टर',

    // Statuses
    assigned: 'नियुक्त',
    pending: 'प्रलंबित',
    completed: 'पूर्ण',
    cancelled: 'रद्द',
    accepted: 'स्वीकारले',
    rejected: 'नाकारले',

    // Payment Methods
    cash: 'रोख',
    online: 'ऑनलाइन',

    // Error Messages
    errorAccessRestricted: 'केवळ शेतकऱ्यांसाठी प्रवेश प्रतिबंधित आहे.',
    errorPleaseLogIn: 'कृपया शेतकरी म्हणून लॉग इन करा.',
    errorFetchingOrders: 'ऑर्डर आणण्यात त्रुटी: {message}',
    errorInitialization: 'प्रारंभ त्रुटी: {message}',
    errorAuthentication: 'प्रमाणीकरण त्रुटी: {message}',
    errorInvalidPhone: 'शेतकऱ्याचा फोन नंबर गहाळ किंवा अवैध आहे.',
    errorSendingWhatsApp: 'व्हाट्सएप संदेश पाठवण्यात अयशस्वी: {message}',
    errorCancellingOrder: 'ऑर्डर रद्द करण्यात अयशस्वी: {message}',

    // Success Messages
    successOrderCancelled: 'ऑर्डर यशस्वीरित्या रद्द केले.',

    // WhatsApp Message
    workerAcceptedMessage: 'सर्व कामगारांनी तुमच्या ऑर्डरला स्वीकारले आहे आणि लवकरच तुमच्या स्थानावर ({location}) पोहोचतील. तुम्ही संपर्क करू शकता: {workerDetails}. सादर, खेतिसाथी'
  }
};

export default translationsFarmerDashboard;